import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Assignment as AssignmentIcon } from '@mui/icons-material';
import type { EmailTicketDialogProps } from './types';

const EmailTicketDialog: React.FC<EmailTicketDialogProps> = ({
  open,
  analysis,
  onClose,
  onConfirm,
  formData,
  onFormChange,
  creating = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <AssignmentIcon />
          Ticket aus E-Mail erstellen
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {analysis && (
          <Box mb={2}>
            <Alert severity={analysis.sollTicketErstellen ? 'info' : 'warning'} sx={{ mb: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                KI-Empfehlung:
              </Typography>
              <Typography variant="body2">
                {analysis.grund}
              </Typography>
            </Alert>
          </Box>
        )}

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Titel *"
            value={formData.titel}
            onChange={(e) => onFormChange({ titel: e.target.value })}
            fullWidth
            required
          />

          <TextField
            label="Was (Beschreibung) *"
            value={formData.was}
            onChange={(e) => onFormChange({ was: e.target.value })}
            multiline
            rows={4}
            fullWidth
            required
          />

          <TextField
            label="Wie (Lösung/Vorgehen)"
            value={formData.wie}
            onChange={(e) => onFormChange({ wie: e.target.value })}
            multiline
            rows={3}
            fullWidth
          />

          <TextField
            label="Wann (Fälligkeitsdatum)"
            type="datetime-local"
            value={formData.wann}
            onChange={(e) => onFormChange({ wann: e.target.value })}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />

          <FormControl fullWidth>
            <InputLabel>Priorität</InputLabel>
            <Select
              value={formData.prioritaet}
              label="Priorität"
              onChange={(e) => onFormChange({ prioritaet: e.target.value })}
            >
              <MenuItem value="Niedrig">Niedrig</MenuItem>
              <MenuItem value="Mittel">Mittel</MenuItem>
              <MenuItem value="Hoch">Hoch</MenuItem>
              <MenuItem value="Kritisch">Kritisch</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={formData.status}
              label="Status"
              onChange={(e) => onFormChange({ status: e.target.value })}
            >
              <MenuItem value="Offen">Offen</MenuItem>
              <MenuItem value="In Bearbeitung">In Bearbeitung</MenuItem>
              <MenuItem value="Wartend">Wartend</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={creating || !formData.titel.trim() || !formData.was.trim()}
          startIcon={creating ? <CircularProgress size={16} /> : undefined}
        >
          {creating ? 'Erstelle...' : 'Ticket erstellen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailTicketDialog;
